module.exports = __webpack_public_path__ + "img/price-3.a5ecd1f4.png";